import { computed, Injectable, signal } from '@angular/core';

import { ChurnReason, ChurnReasonI } from '@core/churn-flow-types';
import { injectTranslate } from '@core/i18n-legacy';

@Injectable()
export class ChurnFlowReasonsService {
  private readonly t = injectTranslate();

  private readonly otherReason: ChurnReasonI = {
    id: ChurnReason.Other,
    label: this.t('tlc.churn_flow.steps.reasons.reason_8.label'),
    description: this.t('tlc.churn_flow.steps.reasons.reason_8.description'),
    iconName: 'help-outline',
  };

  private readonly reasons = signal<ChurnReasonI[]>([
    {
      id: ChurnReason.TooComplicated,
      label: this.t('tlc.churn_flow.steps.reasons.reason_1.label'),
      description: this.t('tlc.churn_flow.steps.reasons.reason_1.description'),
      iconName: 'sentiment-stressed',
    },
    {
      id: ChurnReason.MissingFeatures,
      label: this.t('tlc.churn_flow.steps.reasons.reason_2.label'),
      description: this.t('tlc.churn_flow.steps.reasons.reason_2.description'),
      iconName: 'assignment-late',
    },
    {
      id: ChurnReason.MovingToAnotherTool,
      label: this.t('tlc.churn_flow.steps.reasons.reason_3.label'),
      description: this.t('tlc.churn_flow.steps.reasons.reason_3.description'),
      iconName: 'arrows-input',
    },
    {
      id: ChurnReason.OrganizationalChanges,
      label: this.t('tlc.churn_flow.steps.reasons.reason_4.label'),
      description: this.t('tlc.churn_flow.steps.reasons.reason_4.description'),
      iconName: 'account-tree',
    },
    {
      id: ChurnReason.NotHiring,
      label: this.t('tlc.churn_flow.steps.reasons.reason_5.label'),
      description: this.t('tlc.churn_flow.steps.reasons.reason_5.description'),
      iconName: 'account-circle-off',
    },
    {
      id: ChurnReason.TooExpensive,
      label: this.t('tlc.churn_flow.steps.reasons.reason_6.label'),
      description: this.t('tlc.churn_flow.steps.reasons.reason_6.description'),
      iconName: 'account-balance-wallet',
    },
    {
      id: ChurnReason.UnhelpfulSupport,
      label: this.t('tlc.churn_flow.steps.reasons.reason_7.label'),
      description: this.t('tlc.churn_flow.steps.reasons.reason_7.description'),
      iconName: 'support-agent',
    },
  ]);

  public readonly randomizedReasons = computed(() => {
    const shuffled = this.shuffle(this.reasons());
    return [...shuffled, this.otherReason];
  });

  private shuffle(array: ChurnReasonI[]): ChurnReasonI[] {
    const arr = array.slice();
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    // ChurnReason.NotHiring should never be the first reason. If it is, swap it with a random other reason.
    if (
      (arr[0]?.id === ChurnReason.NotHiring || arr[1]?.id === ChurnReason.NotHiring) &&
      arr.length > 1
    ) {
      const swapIndex = Math.floor(Math.random() * (arr.length - 1)) + 1;
      [arr[0], arr[swapIndex]] = [arr[swapIndex], arr[0]];
    }
    return arr;
  }
}
